import React from 'react';
import { translate, Trans } from 'react-i18next';
import { Feed, Icon,Button, Modal, Grid, Checkbox,Input} from 'semantic-ui-react';
import {colors, fontSizes, spacings, layout, shadow,buttons, fonts} from 'style';
import GridColumn from 'semantic-ui-react/dist/commonjs/collections/Grid/GridColumn';


var style = {
    header : {
        ...fonts.h3,
        color: colors.themeBlue
    },
    content: {
        fontSize: fontSizes.body,
        lineHeight: '1.5',
        backgroundColor: colors.themeGrey,
    },
    description: {
        ...fonts.body,
        fontSize: fontSizes.body,
        color: colors.themeDarkerGrey,
    },
    button: {
        ...buttons.base,
        display: 'block',
        marginLeft:  'auto',
        marginRight: 'auto',
        marginTop: '20px',
        backgroundColor: colors.warningRed,
    },
    
};

const ReportActivityModal = ({t, 
                            valid,
                            reports, 
                            activity, 
                            busy,
                            onAddReport,
                            onClose,
                            onChangeReasonReport,
                            onChangeCommentReport,
                            reportId,
                            comment}) => (
    <Modal closeIcon open style={style.content} onClose={onClose} size='small'>
        <Modal.Header style={style.header}>{t('Why do you want to report this post?')}</Modal.Header>
        <Modal.Content>
            <Modal.Description style={style.description}>
                <div>
                <Grid stackable>
                    {reports.map((report,index)=>(
                            <Grid.Row key={index}>
                                <Grid.Column width={16}>
                                <Checkbox
                                        label= {report.label}
                                        name='reportReasionActivity'
                                        value={report.id}
                                        checked = {reportId===report.id}
                                        onChange={(event,o)=>onChangeReasonReport(event,o)}
                                        disabled={!valid}
                                    />
                                </Grid.Column>                     
                            </Grid.Row>
                            
                    ))}
                    <Grid.Row key='otherreport'>
                            <Grid.Column width={1}>
                            <Checkbox
                                    name='reportReasionActivity'
                                    value={0}
                                    checked = {!reportId}
                                    onChange={(event,o)=>onChangeReasonReport(event,o)}
                                    disabled={!valid}
                                />
                            </Grid.Column> 
                            <Grid.Column width={10}>
                            <Input name='comment' style={{width:'390px'}} onChange={(event,o)=>onChangeCommentReport(event,o)} value={comment} disabled={!valid}/>
                            </Grid.Column> 
                    </Grid.Row>           
                </Grid>
                </div>
                <div style={style.container}>
                <Button type="button" style={style.button} onClick={()=>onAddReport(activity)} disabled={!valid  || !(reportId > 0 || comment > '')}>{t('Report')}</Button> 
                </div>  
            </Modal.Description>
        </Modal.Content>
    </Modal>
);

export default translate('newsfeed')(ReportActivityModal);



// WEBPACK FOOTER //
// ./src/modules/newsfeed/modal/ReportActivityModal.js